/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil } from 'ml-portals-util-react';
import { MLInsuredCandidatesComponent, MLNameDetailsComponent } from 'ml-components-common-react';
import { convertToSentenceCase } from 'ml-portals-util-js';
import { useModal } from '@jutro/components';
import { LocalDateUtil, EntityUtil } from '@xengage/gw-portals-util-js';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import _ from 'lodash';
import classNames from 'classnames';

import styles from './DriversTableActionComponent.module.scss';
import metadata from './DriversTableActionComponent.metadata.json5';

import { IntlContext } from '@jutro/legacy/locale';

const PA_MODEL_PATH = 'lobData.personalAuto.coverables.value';
const ACTION_ADD_DRIVER = 'add';
const ACTION_REMOVE_DRIVER = 'remove';
const ACTION_EDIT_DRIVER = 'edit';
const HOUSEHOLD_DRIVER_TYPE = 'household';

function DriversTableActionComponent(props) {
    const modalApi = useModal();
    const {
        submissionVM,
        updateWizardData,
        validateNonRatedDrivers,
        clearErrors,
        steps,
        jumpTo,
        hideAdd,
        hideEdit,
        hideRemove,
        hideInsure,
        hideMaritalStatus,
        driverType,
        messages,
        addDriverPopupMetadata,
        addDriverPopupModalBodyStyles,
        typedDrivers,
        setTypedDrivers
    } = props;
    const paModel = _.get(submissionVM, PA_MODEL_PATH);
    const { drivers } = paModel;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const driverTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const relationTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('InsuredRelationType_ML');
    const statusTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');
    const maritalStatusTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('MaritalStatus');
    const genderTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('GenderType');
    const licenseRevoked = statusTypeList.getCode('license_revoked').code;
    const rated = driverTypeList.getCode('rated').code;
    const insure = statusTypeList.getCode('insure_driver').code;
    const unwanted = statusTypeList.getCode('unwanted').code;
    const self = relationTypeList.getCode('self').code;
    const ownInsurance = statusTypeList.getCode('own_insurance').code;
    const neverLicensed = statusTypeList.getCode('never_licensed').code;
    const abroad = statusTypeList.getCode('abroad').code;
    const permit = statusTypeList.getCode('permit').code;
    const mission = statusTypeList.getCode('mission').code;
    const outofhousehold = statusTypeList.getCode('not_household').code;
    const unabletodrive = statusTypeList.getCode('unabletodrive').code;
    const registeredowner = statusTypeList.getCode('registeredowner').code;
    const deceased = statusTypeList.getCode('deceased').code;
    const unknown = statusTypeList.getCode('unknown').code;
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const isExclusionAllowed = _.get(submissionVM, 'baseData.canExcludeDrivers_ML.value', true);

    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');

    const driverStepName = '/drivers';
    const [addedDriver, setAddedDriver] = useState({});
    const [error, setError] = useState(null);
    const [removeError, setRemoveError] = useState(null);
    const [undoEditDriver, setUndoEditDriver] = useState(null);
    const isGpa = appConfig.portalCode === 'GPA';
    const isQnB = appConfig.portalCode === 'QB';
    const nbGenderState = _.get(submissionVM,'baseData.isValidNonBinaryGenderState_Ext.value');
    const {
        showProgressDialog
    } = MLModalService();

    const {
        populateDriverPerson,
        getExcludedDriverType,
        validateExcludedDriverAddition,
        getFilteredGender,
        getFullName,
        isDriverHousehold,
        getHouseholdNonDriverType,
        getHouseholdDriverType,
        checkUniqueSelf
    } = MLDriverVehicleUtil();

    const {
        clearManyBlockAlerts,
        addSuccessAlert
    } = MLNotificationBlockUtil();

    const {
        filterAvailableAutoInsuredCandidates,
        addRemovedDriverToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const getRelationshipToInsuredOptions = useCallback(() => {
        return relationTypeList.codes.filter((typeKey) => typeKey.code !== self).map((category) => {
            return {
                code: category.code,
                name: translator({
                    id: category.name,
                    defaultMessage: category.name
                })
            };
        });
    }, [relationTypeList.codes, self, translator]);

    const isStateORFn = (state) => state === 'OR';
    const isStateSCFn = (state) => state === 'SC';

    const getReasonExcludedOptions = useCallback(() => {
        let typeListValues;
        const policyStateCode = submissionVM.baseData.policyAddress.state.value.code; 
        const isStateOR = isStateORFn(policyStateCode)
        const isStateSC = isStateSCFn(policyStateCode)
        if (driverType === getExcludedDriverType()) {
            if (submissionVM?.isModernProduct_Ext?.value) {
                 if(isStateSC) {
                    typeListValues = statusTypeList.codes.filter((val) => val.code === ownInsurance || val.code === unabletodrive);
                } else if(isStateOR) {
                    typeListValues = statusTypeList.codes.filter((val) => val.code === licenseRevoked || val.code === unwanted || val.code === ownInsurance
                    || val.code === unabletodrive);
                } else {
                    typeListValues = statusTypeList.codes.filter((val) => val.code === licenseRevoked || val.code === unwanted || val.code === ownInsurance
                    || val.code === unabletodrive || val.code === registeredowner);
                }
            } else {
                typeListValues = statusTypeList.codes.filter((val) => val.code === licenseRevoked || val.code === unwanted);
            }
        } else {
            if (submissionVM?.isModernProduct_Ext?.value) {
                if (isExclusionAllowed) {
                    typeListValues = statusTypeList.codes.filter((val) => val.code === unknown || val.code === abroad || val.code === permit || val.code === mission
                        || val.code === deceased || val.code === outofhousehold || ((isStateOR || isStateSC) && val.code === registeredowner));
                } else {
                    typeListValues = statusTypeList.codes.filter((val) => val.code === unknown || val.code === ownInsurance || val.code === abroad || val.code === permit || val.code === mission
                        || val.code === unabletodrive || val.code === registeredowner || val.code === deceased || val.code === outofhousehold);
                }
            } else {
                typeListValues = statusTypeList.codes.filter((val) => val.code === ownInsurance || val.code === neverLicensed || val.code === abroad || val.code === permit || val.code === mission);
            }
        }
        return typeListValues.map((category) => {
            return {
                code: category.code,
                name: translator({
                    id: category.name,
                    defaultMessage: category.name
                })
            };
        });
    }, [abroad, deceased, driverType, getExcludedDriverType, licenseRevoked, mission, neverLicensed, ownInsurance, permit, registeredowner, statusTypeList.codes, translator, unabletodrive, unwanted]);

    const isSecondaryNamedInsuredErrorMessage = (errorMsg) => {
        return (driverType === getExcludedDriverType()) ? errorMsg === messages.SecondaryNamedInsuredExclusion.defaultMessage : false;
    };

    const addAlert = useCallback((driver) => {
        clearManyBlockAlerts(['AddDriver', 'driverRemoved']);

        let alertMsg;
        if (isModernProduct) {
            alertMsg = {...messages.DriverAddedAlertNewProduct, args: { person: driver.person.displayName.value }};
        } else {
            alertMsg = {...messages.DriverAddedAlert, args: { person: driver.person.displayName.value }};
        }
        const alertName = `AddDriver`;
        const alertHelpTitle = messages.DriverHelpTitle;
        const alertHelpMessage = messages.DriverHelpText;
        addSuccessAlert(alertMsg, alertName, null, alertHelpTitle, alertHelpMessage);
    }, [clearManyBlockAlerts, messages, addSuccessAlert]);

    const showErrorIcon = useCallback((driver) => {
        const driverVM = viewModelService.create(driver, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO');
        return !driverVM.aspects.valid || !driverVM.aspects.subtreeValid;
    }, [viewModelService]);

    const updateDrivers = useCallback(() => {
        const driversToSet = drivers.filter((driver) => {
            if (driverType === 'household') {
                return isDriverHousehold(driver);
            }
            return driver.type_ML === driverType;
        });
        driversToSet.forEach((driver) => {
            // eslint-disable-next-line no-param-reassign
            driver.error = showErrorIcon(driver);
        });
        setTypedDrivers(driversToSet);
    }, [drivers, driverType, showErrorIcon]);

    const undoDriverEdit = useCallback(() => {
        const indexTodriverToUndo = drivers.indexOf(undoEditDriver);
        if (indexTodriverToUndo !== -1) {
            drivers.splice(indexTodriverToUndo, 1, undoEditDriver);
            updateDrivers();
        }
    }, [drivers, undoEditDriver, updateDrivers]);

    const addDriver = useCallback((driverToBeSaved) => {
        drivers.push(driverToBeSaved.value);
        updateWizardData(submissionVM);
    }, [drivers, submissionVM, updateWizardData]);

    const editDriver = useCallback((driverToBeSaved) => {
        let currentDriverIndex = -1;
        if (driverToBeSaved.publicID.value) {
            currentDriverIndex = drivers.findIndex((drv) => { return drv.publicID === driverToBeSaved.publicID.value; });
        } else {
            currentDriverIndex = drivers.findIndex((drv) => { return drv.tempID === driverToBeSaved.tempID.value; });
        }
        if (currentDriverIndex !== -1) {
            drivers[currentDriverIndex] = driverToBeSaved.value;
        }
        updateWizardData(submissionVM);
    }, [drivers, submissionVM, updateWizardData]);

    const addNewDriverModel = useCallback(
        () => {
            const driverObj = {
                accidents: '0',
                violations: '0',
                tempID: EntityUtil.nextId()
            };
            driverObj.person = {
                tempID: EntityUtil.nextId(),
                primaryAddress: submissionVM.baseData.policyAddress.value,
                middleName: null
            };
            driverObj.licenseState = driverObj.person.primaryAddress.state;

            // set partialDriverAdditionFlag_ML to "true" to avoid requiredness for other fields
            driverObj.partialDriverAdditionFlag_ML = true;
            driverObj.type_ML = driverType;
            driverObj.error = {
                message: null
            };
            driverObj.editMode_ML = true;
            setAddedDriver(driverObj);

            const driverVM = viewModelService.create(driverObj, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO');

            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Driver`);

            return driverVM;
        },
        [driverType, submissionVM.baseData.policyAddress.value, viewModelService]
    );

    const onAddDriver = useCallback(() => {
        filterAvailableAutoInsuredCandidates(submissionVM, drivers);
        const driverVM = addNewDriverModel();
        const addDriverModelTitle = submissionVM.isModernProduct_Ext?.value && driverType === HOUSEHOLD_DRIVER_TYPE ? `${translator(messages.ModernProductDriverPopupTitle)}` : `${translator(messages.DriverPopupTitle)}`;
        let validationErrorMessage = null;
        let showValidationError = false;
        let insuredCandidateSelected = false;
        const setInsuredCandidateSelected = (bool) => {
            validationErrorMessage = null;
            showValidationError = false;
            insuredCandidateSelected = bool;
        };

        const onSaveDriver = (driverToBeSaved) => {
            if (!insuredCandidateSelected) {
                validationErrorMessage = translator(messages.SelectDriver);
                showValidationError = true;
                return false;
            }
            if ((driverToBeSaved.value.status_ML === 'unwanted' || driverToBeSaved.value.status_ML === 'license_revoked') && driverToBeSaved.value.licenseState === 'SC') {
                    driverToBeSaved.type_ML.value = 'rated';
                }
            driverToBeSaved.person.dateOfBirth.value = driverToBeSaved.dateOfBirth.value;
            if (driverType === getExcludedDriverType()) {
                const validationResult = validateExcludedDriverAddition(driverToBeSaved, submissionVM, drivers);
                if (!validationResult.hasError || driverToBeSaved.value.licenseState === 'CO') {
                    validationErrorMessage = null;
                    showValidationError = false;
                } else {
                    validationErrorMessage = validationResult.errorMessage;
                    showValidationError = true;
                    return false;
                }
            } else if (driverType === getHouseholdDriverType()) {
                driverToBeSaved.type_ML.value = getHouseholdNonDriverType(driverToBeSaved.value, isModernProduct);
            }
            populateDriverPerson(driverToBeSaved.value);

            addDriver(driverToBeSaved);
            updateDrivers();
            addAlert(driverToBeSaved);
            window.scrollTo(0, 0);
            return true;
        };

        const componentProps = {
            title: addDriverModelTitle,
            uiProps: addDriverPopupMetadata.pageContent,
            viewModel: driverVM,
            viewModelService: viewModelService,
            actionBtnLabel: platformMessages.mlContinue,
            modalBodyStyles: addDriverPopupModalBodyStyles,
            showBannerMessage: true,
            // overrideProps: addDriverModalOverrides,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: {
                        submissionVM,
                        driverVM,
                        driverType,
                        setInsuredCandidateSelected,
                        partialDriverAdditionFlag: true,
                        viewModelService
                    },
                    formFieldsContainer: {
                        visible: insuredCandidateSelected
                    },
                    nameDetailsComponent: {
                        layout: 'ML-Name-Default',
                        personVM: driverVM.person,
                        // to identify as a Component for FormModalPopover to attach onValidate function
                        isComponent: true
                    },
                    relationship: {
                        availableValues: getRelationshipToInsuredOptions()
                    },
                    reason: {
                        availableValues: getReasonExcludedOptions()
                    },
                    secondaryNamedInsuredTooltipDiv: {
                        visible: isSecondaryNamedInsuredErrorMessage(validationErrorMessage)
                    },
                    secondaryNamedInsuredTooltipComponent: {
                        visible: !isGpa
                    },
                    errorNotification: {
                        visible: showValidationError
                    },
                    validationErrorMessage: {
                        content: validationErrorMessage
                    },
                    genderRow: {
                        availableValues: getFilteredGender(nbGenderState),
                        className: isQnB ? 'radioButtonQnB row col-md-4 vertical-spacing-10' : 'row col-md-4 vertical-spacing-10'
                    },
                    dobRow:{
                        className: `row ${isQnB ? 'help-text-row-qb' : 'help-text-row'} vertical-spacing-40 col-md-12`
                    },
                    checkUniqueSelf: {
                        visible: drivers && !checkUniqueSelf([driverVM.value, ...drivers])
                    },
                    dob:{
                        maxDate: getTodaysDate(),                 
                    }
                };
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent
            },
            onSaveAction: onSaveDriver
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [addAlert, addDriver, addDriverPopupMetadata.pageContent, addDriverPopupModalBodyStyles, addNewDriverModel, driverType, drivers, filterAvailableAutoInsuredCandidates, getExcludedDriverType, getReasonExcludedOptions, getRelationshipToInsuredOptions, isGpa, isSecondaryNamedInsuredErrorMessage, messages.DriverPopupTitle, populateDriverPerson, submissionVM, translator, updateDrivers, validateExcludedDriverAddition, viewModelService]);

    const editDriverModal = useCallback((index, driverValFromRedirect) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit Excluded Driver`);
        let driverToEdit;
        if (_.isUndefined(index) && !_.isUndefined(driverValFromRedirect)) {
            driverToEdit = driverValFromRedirect;
        } else {
            driverToEdit = typedDrivers[index.index];
        }
        const driverVM = viewModelService.create(driverToEdit, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO');
        // driverVM.value = driverToEdit;
        setUndoEditDriver(driverVM.value);
        driverVM.editMode_ML.value = true;
        let validationErrorMessage = null;
        let showValidationError = false;

        const onSaveEditedDriver = (driverToBeSaved) => {
            if ((driverToBeSaved.value.status_ML === 'unwanted' || driverToBeSaved.value.status_ML === 'license_revoked') && driverToBeSaved.value.licenseState === 'SC') {
                    driverToBeSaved.type_ML.value = 'rated';
                }
            if (driverType === getExcludedDriverType()) {
                // eslint-disable-next-line no-param-reassign
                if (driverToBeSaved.value.status_ML === 'registeredowner' && driverToBeSaved.value.licenseState === 'OR') {
                    driverToBeSaved.type_ML.value = getHouseholdNonDriverType(driverToBeSaved.value, isModernProduct, true, driverToBeSaved.value.licenseState);
                }
                    const validationResult = validateExcludedDriverAddition(driverToBeSaved, submissionVM, drivers);

                    if (!validationResult.hasError) {
                        validationErrorMessage = null;
                        showValidationError = false;
                    } else {
                        validationErrorMessage = validationResult.errorMessage;
                        showValidationError = true;
                        return false;
                }
            } else if (driverType === getHouseholdDriverType()) {
                driverToBeSaved.type_ML.value = getHouseholdNonDriverType(driverToBeSaved.value, isModernProduct);
            }

            editDriver(driverToBeSaved);
            updateDrivers();
            addAlert(driverToBeSaved);
            window.scrollTo(0, 0);
            return true;
        };

        const editDriverModelTitle = submissionVM.isModernProduct_Ext?.value  && driverType === HOUSEHOLD_DRIVER_TYPE ? `${translator(messages.ModernProductEditDriverPopupTitle)}` : `${translator(messages.EditDriverPopupTitle)}`;

        const componentProps = {
            title: editDriverModelTitle,
            uiProps: addDriverPopupMetadata.pageContent,
            viewModel: driverVM,
            viewModelService: viewModelService,
            actionBtnLabel: platformMessages.mlContinue,
            modalBodyStyles: addDriverPopupModalBodyStyles,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: {
                        visible: false
                    },
                    nameDetailsComponent: {
                        layout: 'ML-Name-Default',
                        personVM: driverVM.person,
                        // to identify as a Component for FormModalPopover to attach onValidate function
                        isComponent: true
                    },
                    relationship: {
                        availableValues: getRelationshipToInsuredOptions()
                    },
                    reason: {
                        availableValues: getReasonExcludedOptions()
                    },
                    secondaryNamedInsuredTooltipDiv: {
                        visible: isSecondaryNamedInsuredErrorMessage(validationErrorMessage)
                    },
                    errorNotification: {
                        visible: showValidationError,
                    },
                    validationErrorMessage: {
                        content: validationErrorMessage
                    },
                    genderRow: {
                        availableValues: getFilteredGender(nbGenderState),
                        className: isQnB ? 'radioButtonQnB row col-md-4 vertical-spacing-10' : 'row col-md-4 vertical-spacing-10'
                    },
                    dobRow:{
                        className: `row ${isQnB ? 'help-text-row-qb  vertical-spacing-40' : 'help-text-row  vertical-spacing-40 col-md-12'}`
                    },
                    checkUniqueSelf: {
                        visible: drivers && !checkUniqueSelf(drivers)
                    },
                    dob:{
                        maxDate: getTodaysDate()                    
                    }
                };
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent
            },
            onSaveAction: onSaveEditedDriver,
            onReject: undoDriverEdit
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [viewModelService, translator, messages.EditDriverPopupTitle, addDriverPopupMetadata.pageContent, addDriverPopupModalBodyStyles, undoDriverEdit, typedDrivers, driverType, getExcludedDriverType, submissionVM, updateDrivers, addAlert, validateExcludedDriverAddition, drivers, editDriver, getRelationshipToInsuredOptions, getReasonExcludedOptions, isSecondaryNamedInsuredErrorMessage]);

    const getTodaysDate = useCallback(() => {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate());
    });
    const onEditDriver = useCallback((index) => {
        editDriverModal(index);
    }, [editDriverModal]);

    const undoDriverRemoval = useCallback((driver) => {
        drivers.push(driver);
        updateDrivers();
        clearManyBlockAlerts(['AddDriver', 'driverRemoved']);
        if (validateNonRatedDrivers) {
            validateNonRatedDrivers();
        }
    }, [clearManyBlockAlerts, drivers, updateDrivers, validateNonRatedDrivers]);

    const addRemovalAlert = useCallback((driver) => {
        clearManyBlockAlerts(['AddDriver', 'driverRemoved']);
        const alert = {
            id: 'driverRemoved',
            message: {...messages.DriverRemoved, args: { person: driver.person.displayName }}
        };
        addSuccessAlert(alert.message, alert.id, () => undoDriverRemoval(driver))
    }, [addSuccessAlert, clearManyBlockAlerts, messages.DriverRemoved, undoDriverRemoval]);

    const onRemoveDriver = useCallback((index, driverValFromRedirect) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Excluded Driver`);
        let driverToRemove;
        if (_.isUndefined(index) && !_.isUndefined(driverValFromRedirect)) {
            driverToRemove = driverValFromRedirect;
        } else {
            driverToRemove = typedDrivers[index.index];
        }
        addRemovedDriverToAvailableCandidates(submissionVM, driverToRemove);
        paModel.removeDriver(driverToRemove);
        if (_.get(submissionVM, 'aspects.valid') && _.get(submissionVM, 'aspects.subtreeValid')) {
            updateWizardData(submissionVM);
        }
        updateDrivers();
        addRemovalAlert(driverToRemove);
        window.scrollTo(0, 0);
    }, [paModel, addRemovedDriverToAvailableCandidates, submissionVM, updateDrivers, addRemovalAlert, typedDrivers, updateWizardData]);

    const jumpToStep = useCallback((stepName) => {
        const indexOfDriverDetails = _.findIndex(
            steps,
            ({ path }) => path === stepName
        );
        jumpTo(indexOfDriverDetails);
    }, [jumpTo, steps]);

    const onInsureDriver = useCallback( async(index) => {
        const tmp = typedDrivers[index.index];
        let currentDriverIndex = -1;
        if (tmp.publicID) {
            currentDriverIndex = drivers.findIndex((drv) => { return drv.publicID === tmp.publicID; });
        } else {
            currentDriverIndex = drivers.findIndex((drv) => { return drv.tempID === tmp.tempID; });
        }
        if (currentDriverIndex !== -1) {
            const driver = drivers[currentDriverIndex];
            driver.status_ML = insure;
            driver.type_ML = rated;
            updateDrivers();
            updateWizardData(submissionVM);
            jumpToStep(driverStepName);
        }
    }, [typedDrivers, insure, rated, updateDrivers, submissionVM, updateWizardData, jumpToStep, drivers]);

    const intl = useContext(IntlContext);
    const getFormattedDateString = useCallback((gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }, [intl]);

    const isExcludedIncomplete = (driver) => {
        return driver.maritalStatus_ML === undefined || showErrorIcon(driver);
    };

    const generateDriverOverrides = () => {
        if (typedDrivers) {
            const getTypeKeyDescription = (typeKeyName) => {
                return translator({
                    id: typeKeyName,
                    defaultMessage: typeKeyName
                });
            };

            const overrides = typedDrivers.map((driver, index) => {
                const showExcludedErrorIcon = driver.type_ML === 'excluded' ? isExcludedIncomplete(driver) : false;
                return {
                    [`nameCellStatusContainer${index}`]: {
                        className: classNames(showExcludedErrorIcon ? 'error-text' : null)
                    },
                    [`nameCell${index}`]: {
                        content: getFullName(driver.person).toUpperCase()
                    },
                    [`nameCellStatus${index}`]: {
                        visible: _.isString(driver.error) || showExcludedErrorIcon
                    },
                    [`dobCell${index}`]: {
                        content: getFormattedDateString(driver.dateOfBirth)
                    },
                    [`genderCell${index}`]: {
                        content: driver.gender !== undefined ? getTypeKeyDescription(genderTypeList.getCode(driver.gender).name) : ''
                    },
                    [`maritalStatusCellContent${index}`]: {
                        visible: !hideMaritalStatus
                    },
                    [`maritalStatusCell${index}`]: {
                        content: driver.maritalStatus_ML !== undefined ? getTypeKeyDescription(maritalStatusTypeList.getCode(driver.maritalStatus_ML).name) : ''
                    },
                    [`relationshipToInsuredCell${index}`]: {
                        content: driver.relationshipToInsured_ML !== undefined ? getTypeKeyDescription(relationTypeList.getCode(driver.relationshipToInsured_ML).name) : ''
                    },
                    [`reasonNotListedCell${index}`]: {
                        content: driver.status_ML ? getTypeKeyDescription(statusTypeList.getCode(driver.status_ML).name) : ''
                    },
                    [`editActionCell${index}`]: {
                        visible: !hideEdit,
                        content: 'Edit',
                        className: "remove-txt-decoration",
                        'aria-labelledby': `editActionCell${index} nameCellContent${index} dobCellContent${index} genderCellContent${index} maritalStatusCellContent${index} relationshipToInsuredCellContent${index} reasonNotListedCellContent${index}`
                    },
                    [`insureActionCell${index}`]: {
                        visible: !hideInsure,
                        content: 'Insure',
                        className: "remove-txt-decoration",
                        'aria-labelledby': `insureActionCell${index} nameCellContent${index} dobCellContent${index} genderCellContent${index} maritalStatusCellContent${index} relationshipToInsuredCellContent${index} reasonNotListedCellContent${index}`
                    },
                    [`removeActionCell${index}`]: {
                        visible: !hideRemove && !driver.fromPrefill_ML,
                        content: 'Remove',
                        className: "remove-txt-decoration",
                        'aria-labelledby': `removeActionCell${index} nameCellContent${index} dobCellContent${index} genderCellContent${index} maritalStatusCellContent${index} relationshipToInsuredCellContent${index} reasonNotListedCellContent${index}`
                    },
                };
            });
            return Object.assign({}, ...overrides);
        }
        return {};
    };

    // Start Redirect Functions
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_ADD_DRIVER) {
                onAddDriver();
            } else if (redirectAction.action === ACTION_EDIT_DRIVER) {
                // Pass undefined as first param for index from button click
                editDriverModal(undefined, redirectAction.model);
            } else if (redirectAction.action === ACTION_REMOVE_DRIVER) {
                // Pass undefined as first param for index from button click
                onRemoveDriver(undefined, redirectAction.model);
            }
        }
    };

    useEffect(() => {
        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML) && stepDataML.type === driverType) {
            handleStepAction(stepDataML);
            _.set(submissionVM, 'value.wizardActionDataML', {});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    const renderRemoveError = () => {
        return (removeError !== null)
            ? (
                <div>
                    <span className="icon-ml-alert-icon" />
                    {removeError}
                </div>
            )
            : null;
    };

    const overrideProps = {
        driverHeader: {
            content: submissionVM.isModernProduct_Ext.value && driverType === HOUSEHOLD_DRIVER_TYPE ? translator(messages.ModernProductDriverHeader) : translator(messages.DriverHeader)
        },
        driverParagraph: {
            content: submissionVM.isModernProduct_Ext.value && driverType === HOUSEHOLD_DRIVER_TYPE ? translator(messages.ModernProductDriverParagraph) : translator(messages.DriverParagraph),
            className: isQnB ? "body-copy vertical-spacing-20 text-primary-color" : "body-copy light vertical-spacing-20"
        },
        driverRemovalError: {
            visible: removeError !== null,
            content: renderRemoveError()
        },
        driversIterable: {
            data: typedDrivers
        },
        maritalStatusCellHeader: {
            visible: !hideMaritalStatus
        },
        mlTableActionsDefaultButton: {
            className: isQnB ? 'display-inline-block margin-top-20 secondaryButton w-auto' : 'display-inline-block margin-top-20',
            visible: !hideAdd,
            content: isQnB
                ? convertToSentenceCase(
                    translator(
                        submissionVM.isModernProduct_Ext?.value && driverType === HOUSEHOLD_DRIVER_TYPE
                        ? messages.ModernProductAddDriver
                        : messages.AddDriver
                    )
                    )
                : translator(
                    submissionVM.isModernProduct_Ext?.value && driverType === HOUSEHOLD_DRIVER_TYPE
                        ? messages.ModernProductAddDriver
                        : messages.AddDriver
                    ),
            onClick: onAddDriver
        },
        DriverTable: {
            'aria-label': submissionVM.isModernProduct_Ext?.value && driverType === HOUSEHOLD_DRIVER_TYPE ? translator(messages.ModernProductDriverHeader) : translator(messages.DriverHeader)
        },
        genderRow: {
            className: isQnB ? 'radioButtonQnB row col-md-4 vertical-spacing-10' : 'row col-md-4 vertical-spacing-10'
        },
        ...generateDriverOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onEditDriver,
            onAddDriver,
            onInsureDriver,
            onRemoveDriver,
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            onModelChange={updateWizardData}
        />
    );
}


DriversTableActionComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    updateWizardData: PropTypes.func.isRequired,
    validateNonRatedDrivers: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    jumpTo: PropTypes.func.isRequired,
    hideAdd: PropTypes.bool,
    hideEdit: PropTypes.bool,
    hideRemove: PropTypes.bool,
    hideInsure: PropTypes.bool,
    hideMaritalStatus: PropTypes.bool,
    driverType: PropTypes.string.isRequired,
    messages: PropTypes.shape({}).isRequired,
    addDriverPopupMetadata: PropTypes.shape({}).isRequired,
    addDriverPopupModalBodyStyles: PropTypes.shape({}).isRequired
};

DriversTableActionComponent.defaultProps = {
    hideAdd: true,
    hideEdit: true,
    hideRemove: true,
    hideInsure: true,
    hideMaritalStatus: true
};

export default DriversTableActionComponent;
